export default __webpack_public_path__ + "static/media/Letters3_17.2a2a4732.png";